import { Component } from '@angular/core';
import { JobsJobPostingSourceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Job Posting Sources') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-jobsjobpostingsource-form',
    templateUrl: './jobsjobpostingsource.form.component.html'
})
export class JobsJobPostingSourceFormComponent extends BaseFormComponent {
    public record!: JobsJobPostingSourceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

